<template>
    <!-- <div class="mooc-charge-courseware-preview" @mousemove="move()" > -->
    <div class="mooc-charge-courseware-preview" >
        <!-- 题目弹窗-->
        <Modal ref="modal" v-model="questionVideoModal" title="测评题" :closable="false" :mask-closable="false" footer-hide class="mooc-charge-preview-modal" @on-visible-change="colseModal">
            <!-- 题型 -->
            <div class="question-stem-preview">
                <span class="question-stem-content-preview">{{ baseTypeLabel }}</span>
                <span v-if="this.learnRecord.isPass == true" class="pass">回答正确！</span>
                <span v-else-if="this.learnRecord.isPass == false" class="fail">回答错误！</span>
            </div>
            <!-- 题干 -->
            <div class="question-stem-preview">
                <span v-if="question.snLabel" class="sn-label-preview">{{ question.snLabel }}</span>
                <span class="question-stem-content-preview" v-html="question.questionStem"/>
            </div>
            <!-- 选项 1: 单选题和多选题 -->
            <div class="question-options">
                <div v-for="(option, index) in question.optionList" :key="index" :class="{ correct: option.checked }" class="question-option">
                    <div :class="{ correct: option.checked }" class="mark" @click="chooiceAnswer(question, index)">{{ option.quesValue }}</div>
                    <div v-html="option.quesOption" class="option-list"></div>
                </div>
            </div>
            <!-- 解析 -->
            <div class="question-analysis-preview-box" v-show="showAnalysis">
                <div class="question-analysis-preview">
                    <div class="positiveSolution"></div>
                    <span class="title-desc-preview">【解析】</span>
                    <div class="question-analysis-content-preview" v-html="question.analysis"></div>
                </div>
                <!-- 考核点 -->
                <div class="question-knowledge-point-preview">
                    <span class="title-desc-preview">【考核点】</span>
                    <div class="question-analysis-content-preview" v-html="question.examinePoint"></div>
                </div>
            </div>
            <div class="button-box-preview">
                <Button v-if="buttonType == 1" type="primary" @click="sumbitAnswer">提交</Button>
                <Button v-else type="primary" @click="videoCancel">关闭</Button>
            </div>
        </Modal>
        <Modal
            class="mooc-charge-relearn-modal"
            ref="reLearnRef"
            v-model="reLearnModel"
            title="学习提醒"
            :closable="false" :mask-closable="false"
            width="300">
            <p>在人社部门]监管抽查中发现该章节课程学习过程无有效监管记录，需要重新学习。</p>
            <div slot="footer">
                <Button type="primary" @click="okRelearn">确定 {{countDownTime}} s</Button>
            </div>
        </Modal>
        <!-- 人脸识别组件 -->
        <FaceRecognition ref="refOnHookFace" :key="componentKeyFace" v-if="faceRecognition" @colseFaceModal="colseFaceModal"/>
        <!-- 验证码组件 -->
        <ValidateCode ref="refOnHookCode" :key="componentKeyCode" v-if="validateCode" @colseCodeModal="colseCodeModal"/>
        <!-- 录制视频组件 -->
        <VideoRecording ref="videoRecord" v-if="videoRecording" @colseVideoRecordModal="colseVideoRecordModal"/>
        <!-- <Modal v-model="alertModal" class="mooc-charge-alert-modal" title="提示" footer-hide :closable="false" :mask-closable="false" @on-visible-change="colseAlertModal">
            <Alert type="error" show-icon >
                    <Icon type="md-sad" slot="icon" size="35" color="red" />
                    <template slot="desc">
                        学员您好，当前系统已经停止计时，为了确认您是否在计算机面前，特此弹出对话框询问，如有带来不便，请您谅解！
                    </template>
                </Alert>
            <div class="button-box-preview">
                <Button class="btn" type="primary" @click="move()">确定</Button>
            </div>
        </Modal> -->
        <!-- 课件播放 -->
        <h3 id="h3">{{mediaTitle}}</h3>
        <dl class="mediaDuration">
            <dt>{{ showName }}</dt>
            <dd>总时长：{{duration}}</dd>
            <div class="chain-broadcast">
                <span class="chain-title">连续播放:</span>
                <i-switch v-model="episodicStatus">
                    <span slot="open">开</span>
                    <span slot="close">关</span>
                </i-switch>
            </div>
        </dl>
        <div class="video-conct">
            <div class="video-box">
                <div class="prism-player-mooc" id="mooc_player"></div>
                <!-- <div class="proogress-x">
                    <div class="progress">
                        <div class="played" :style="'width:' + progressTime + '%'"></div>
                    </div>
                </div> -->
            </div>
            <!-- 右侧菜单栏 -->
            <div class="video-nav">
                <div class="video-box-right">
                    <div @click="changeType(1)" :class="{actived: type == 1}" style="float: left;"><Icon type="md-reorder"/><span>目录</span></div>
                    <div v-if="nodeData.lectures.length > 0" @click="changeType(2)" :class="{actived: type == 2}"><Icon type="ios-book-outline"/><span>讲义</span></div>
                    <div v-if="nodeData.catalogKnowledgePoints.length > 0" @click="changeType(3)" :class="{actived: type == 3}"><Icon type="ios-bulb-outline"/><span>知识点</span></div>
                </div>
                <div class="video-box-left">
                    <div class="fold">></div>
                    <!-- 章节 -->
                    <Tree v-if="type == 1" :data="chapters" :render="renderContent"></Tree>
                    <!-- 讲义 -->
                    <div v-if="type == 2" class="brief handout">
                    <ul v-if="nodeData.lectures.length > 0" class="handout-list">
                        <li v-for="(site,index) in nodeData.lectures" :key="index">
                            <p class="title">讲义{{ index+1 }}<span class="minute">{{ initTime(site.startTime) }}</span>-<span class="second">{{ initTime(site.endTime) }}</span></p>
                            <div v-html="site.content"/>
                            <h1></h1>
                        </li>
                    </ul>
                    <Nodata v-else :size="100" :type="2" class="no-data">该章节暂无讲义</Nodata>
                    </div>
                    <!-- 知识点 -->
                    <div v-if="type == 3" class="brief knowledge-points">
                        <ul v-if="nodeData.catalogKnowledgePoints.length > 0" class="knowledge-points-list">
                            <li v-for="(site,index) in nodeData.catalogKnowledgePoints" :key="index">
                                <p class="title">知识点{{ index+1 }}<span>{{ initTime(site.startTime) }}-{{ initTime(site.endTime) }}</span></p>
                                <div class="points">
                                <span v-for="(point, index) in site.knowledgePoints" :key="index"> {{ point.title }}</span>
                                </div>
                            </li>
                        </ul>
                        <Nodata v-else :size="100" :type="2" class="no-data">该章节暂无知识点</Nodata>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GuangYuanDao from '@/../public/static/js/dao/GuangYuanDao';
import FaceRecognition from '@/components/FaceRecognition';
import VideoRecording from '@/components/VideoRecording';
import ValidateCode from '@/components/ValidateCode';

export default {
    components: { FaceRecognition, VideoRecording, ValidateCode },

    data () {
        return {
            reLearnModel     : false, // 重学提示
            countDownTime : 5, // 倒计时
            componentKeyFace       : 10000, // 组件key
            componentKeyCode       : 0, // 组件key
            questionVideoModal     : false, // 是否开启弹题窗口
            // spinShow               : false, // 加载动画
            // msgModal               : false, // 人脸识别错误提示
            // iframeModal            : false, // 摄像头启动失败引用 iframeModal 提示
            // isDetail               : false, // 摄像头启动失败是否需要查看详情
            // alertModal             : false, // 鼠标不操作提醒对话框
            // warningTime            : 15 * 60 * 1000, // 鼠标不操作提醒时间
            faceInfoModal          : false, // 人脸识别 modal 弹窗
            // faceTask               : null, // 人脸识别认证定时任务
            // isVideo                : true, // 判断是否需要拍照
            faceRecognition: true, // 是否需要人脸识别
            videoRecording: true, // 录制组件
            validateCode: true, // 是否验证码
            startStudyLearn        : false, // 是否首次学习
            type                   : 1, // 1: 章节目录 2                    : 讲义 3: 知识点
            chapters               : [],
            coursewareCode         : '',
            nodeData               : {
                lectures:[],
                catalogKnowledgePoints:[],
            },
            pointsTime             : '', // 创建知识点
            answer                 : '', // 创建答题点
            questionsOpen          : [], // 当前章节所有弹题
            question               : {},
            analysisInvisible      : false,
            lectures               : [], // 当前章节所有讲义
            timers                 : null,
            mediaTitle             : '',
            name                   : '',
            duration               : '',
            uploadedFileUrl        : '',
            oldChapters            : [],
            // client              : {
            //     coursewareCode  : '1454_ept',
            //     userId          : '111',
            //     userName        : '张三',
            //     clientCode      : '852013',
            //     businessLineCode: '',
            //     courseCode      : '',
            //     backUrl         : 'http  : //eplatform.edu-edu.com.cn: 668/cws/cwc/center/record/save'
            // },
            client                 : null, // 第三方登陆客户端信息
            learnRecord            : { },
            recordConfig           : { },
            listenTime             : 1,      // 本次听课累计时长
            listenTimes            : null,   // 累计时长定时任务
            addLearnRecordTimers   : null, // 保存学习记录定时任务
            checkAuthTime          : 1000 * 60 * 5,    // 验证播放权限频率
            recordReturnTime       : 1000 * 60, // 回传记录频率, 默认60秒
            sendNoticeTask         : null, // 通知定时任务
            sendNoticeTaskTime     : 1000 * 60 * 10, // 通知频率, 默认10分钟
            sendNoticeTime         : 0, // 通知增量
            buttonType             : 1,
            showAnalysis           : false,        // 查看题目解析
            rightAnswers           : [],           // 正确答案
            coursewareId           : 0,            // 课件 Id
            medias                 : [],                 // 所有是视频的节点
            episodicStatus         : true,     // 是否连播
            moocPlayer: null, // 慕课播放器
            progressTime: 0, // 当前播放时间点
            recordTime: null, // 视频录制时间点
            options : { // 慕课播放器参数
                autoStart : false,
                // notAllowFullScreen: true, // 禁止全屏
                preload:true,
                // waterMark : true,
                // waterMarkContent : '水印测试',
                // 以下为测试数据，业务中使用请填videoId和signature
                videoData:{
                // adUrl : '../res/pread.mp4',
                    videoImgUrl : 'https://imgsize.ph.126.net/?enlarge=true&imgurl=http://img1.ph.126.net/n5VwluA3g_CDfYXsnRwsEQ==/1561904645785237081.jpg_450x250x0x95.jpg',
                    // start : 5,
                    videoId:0,
                    signature:'',
                    start:0,
                }
            },
        };
    },
    created() {
        // 实时校验权限(防止权限过期继续播放视频)
        setInterval(this.checkClickCookie, this.checkAuthTime);
        // 获取 cookie 中听课记录
        this.checkClickAuth();
        if (this.client != null) {
            this.coursewareCode = this.client.coursewareCode;
            // 查询课件
            this.findCoursewareByCode();
            // 查询章节目录
            this.findChaptersByCoursewareCode();
            // 按顺序过滤出所有视频用于连序播放
            this.filterMedias(this.chapters);
        }
    },
    computed: {
        // 题型
        baseTypeLabel() {
            for (let type of QuesstionType) {
                if (this.question.questionType == type.value) {
                    return type.label;
                }
            }
            return '';
        },
        // 展示课件名称
        showName() {
            var courseName = this.client.courseName;
            if (courseName == 'undefined' || courseName == null || courseName == '') {
                // 修改页面标题
                document.title = this.name;
                return this.name;
            }
            // 修改页面标题
            document.title = courseName;
            return courseName;
        },
        isDrag() {
            return this.client.drag === 1 || (this.recordConfig && this.recordConfig.isSupervise == '1');
        },
        // 设备是否使用中
        // isVideoDevice() {
        //     return this.$store.state.isVideoDevice;
        // }
    },
    mounted() {
        // // 播放用户选择的视频
        // if (JSON.stringify(this.nodeData.media)) {
        //     this.playVideo(this.nodeData);
        // }
        this.$Message.config({
            top: 250,
            duration: 2
        });
    },
    methods: {
        // 重学确认
        okRelearn() {
            this.reLearnModel = false;
            this.countDownTime = 0;
        },
        checkRelearn(data, tyep) {
            var self = this;
            // console.log('', this.countDownTime);
            self.reLearnModel = true;
            this.relearnTask = setInterval(function () {
                // console.log('this.countDownTime', self.countDownTime);
                self.countDownTime--;
                if (self.countDownTime <= 0) {
                    self.reLearnModel = false;
                    data.tagShow = 'none';
                    self.changeMediaUrl(data, tyep);
                    self.countDownTime = 5;
                    clearInterval(self.relearnTask);
                }
            }, 1000);
        },
        leaveConfirm (e) {
            e = e || window.event;
            if (e) {
                e.returnValue = '确定关闭页面吗?';
            }
            return '关闭提示';
        },
        updateRecord () {
            // 调用后台接口
            this.endLearn();
        },
        // 视频录制组件方法
        record(recordTime) {
            // console.log('record-recordTime', recordTime);
            if (this.$refs.videoRecord) this.$refs.videoRecord.recordingVideo(recordTime);
        },
        // 将时间秒转为时分秒格式
        initTime(time) {
            return Utils.getTime(time);
        },
        // 初始化 iview 树
        renderContent (h, { root, node, data }) {
            var noneColor = data.id == this.nodeData.id ? '#5c77fb' : '';
            var learnEnd ='';
            if (data.validTime != data.mediaDuration || data.isMedia != 1) {
                learnEnd = 'none';
            }
            // if (data.id == this.nodeData.id) data.tagShow = 'none';
            var self = this;
            return h('span', {
                class: ['render-content'],
            }, [
                h('span', {
                    style:{
                        // display: 'inline-block',
                        // marginLeft: '5px',
                    },
                }, [
                    h('Tag', {
                        style:{
                            display:data.tagShow,
                        },
                        on: {
                            click:() => {
                                self.changeMediaUrl(data, 1);
                            },
                        },
                        props: Object.assign({}, this.tagProps, {
                            color:'error'
                        }),
                    }, '需重学'),
                ]), h('span', {
                    style:{
                        // display: 'inline-block',
                        // marginLeft: '5px',
                        display:learnEnd,
                    },
                }, [
                    h('Tag', {
                        props: Object.assign({}, this.tagProps, {
                            color:'success'
                        }),
                    }, '已完成'),
                ]),
                h('span', {
                    class: ['tree-node'],
                    id: data.id,
                    style:{
                        color:noneColor,
                        // backg
                    },
                    on:{
                        click:() => {
                            self.changeMediaUrl(data, 1);
                        }
                    },
                }, data.title),
            ]
                // <span class="render-content">
                //     <span id={ data.id } class="tree-node" style={ data.id == this.nodeData.id ? 'color: #5c77fb' : ''  } onClick={() => { this.changeMediaUrl(data, 1); }} >{ data.title }</span>
                // </span>
            );
        },
        // 清除定时任务
        clearTimeOuts() {
            this.listenTime = 1;
            // 清楚上个视频的弹题、讲义、知识点的定时任务
            clearTimeout(this.timers);
            this.timers = null;
            clearTimeout(this.addLearnRecordTimers);
            this.addLearnRecordTimers = null;
            // 固定触发点定时任务任务
            clearTimeout(this.triggerTimeTask);
            this.triggerTimeTask = null;
        },
        //  切换视频 type 为 1 则为手动切换
        changeMediaUrl(data, type) {
            // alert(data.tagShow);
            // 判断当前节点是否是视频
            if (data.isMedia != 1) {
                this.$set(data, 'expand', !data.expand);
                // 当前节点不是视频节点则播放当前节点下的第一个视频, 使用原始的目录查询
                // var media = this.oldChapters.find(x => x.pId == data.id);
                // // 如果下一个也不是视频, 则继续找下一个
                // if (media && media.isMedia != 1) {
                //     this.changeMediaUrl(media, type);
                // } else {
                //     data = media;
                // }
            } else {
                // 和上一次切换的章节不一样时切换
                if (data.id == this.nodeData.id || data.tagShow == '') {
                    if (data.tagShow == '') {
                        this.checkRelearn(data, type);
                    }
                } else {
                    if (this.recordConfig && this.recordConfig.isSupervise == '1') {
                        this.endLearn();
                    }
                    // 保存上个视频切换前的听课记录, 手动切换则需要保存上次听课记录
                    if (this.nodeData.isMedia == 1 && this.learnRecord.learnRecordId && type == 1) {
                        this.insertOrUpdateLearnRecord(true);
                    }
                    // 清除所有定时任务
                    this.clearTimeOuts();
                    // 根据当前章节查询讲义、弹题、知识点
                    this.changeCode(data);
                    // 删除所有创建答题点
                    $('.question-point').remove();
                    // 删除所有创建的知识点
                    $('.importantb').remove();
                    this.playVideo();
                }
            }
        },
        // init true 时判断是否有前置数据验证
        playVideo(init) {
            if (init) {
                // 初始化人脸识别数据
                // this.initFaceInfo();
            }
            console.log('isFinish', this.nodeData.validTime != this.nodeData.mediaDuration);
            // 是否开启监管. 开启监管并未完成, 才进行监管打卡
            if (this.recordConfig && this.recordConfig.isSupervise == '1' && this.nodeData.validTime != this.nodeData.mediaDuration) {
                // 检查是否重新学习
                if (this.nodeData.tagShow == '') {
                    if (!this.relearnTask) {
                        this.checkRelearn(this.nodeData);
                        this.pause();
                    }
                } else {
                    // 开始学习
                    this.startLearn();
                    // 初始化监管数据
                    this.initFaceInfo();
                }
            }

            // 根据服务器编码，获取对应服务器类型
            // 判断视频播放类型(普通 http 或者 ftp 使用 loadByUrl 直接播放，阿里云视频需要删除原来播放器重新创建)
            if (this.nodeData.media.serverCode === 'Mooc') {
                // 本节视频时长
                if (this.moocPlayer) {
                    // console.log('清空播放器');
                    this.moocPlayer.destroy();
                    this.options.videoData = {};
                }
                this.options.parent = document.getElementById('mooc_player');
                this.options.videoData.videoId = this.nodeData.media.mediaSource;
                this.options.videoData.signature = this.nodeData.media.playAuth;
                this.options.videoData.videoImgUrl = this.nodeData.media.coverURL;
                // 初始化进度(上次记录点刚好有弹题，进度设置减少5秒)
                // let seekTime = this.learnRecord.lastTime;
                let filterList = this.questionsOpen.filter(q => q.mediaTime == this.learnRecord.lastTime);
                if (filterList.length > 0 && this.learnRecord.lastTime >= 5) {
                    this.learnRecord.lastTime -= 5;
                }
                // console.log('on-create-seekTime', this.learnRecord.lastTime);
                this.options.videoData.start = this.learnRecord.lastTime;
                this.moocPlayer = EduPlayer.create(this.options);
                this.initPlayerMethods();
            } else {
                this.$Message.warning('(' + this.nodeData.media.serverCode + ')请播放慕课视频!');
            }
        },
        // 创建慕课播放器
        initPlayerMethods() {
            var self = this;
            //点击折叠框
            var fold = 0;
            $('.fold').click(function() {
                fold += 1;
                if (fold%2==0) {
                    // $('.video-box-right').show();
                    $('.video-nav').animate({
                        width : '25vw'
                    });
                    $('.video-box').animate({
                        width : '74vw'
                    });
                    $(this).html('>');
                } else {
                    $(this).html('<');
                    $('.video-nav').animate({
                        width : '1vw'
                    });
                    $('.video-box').animate({
                        width : '99vw'
                    });
                    // $('.video-box-right').hide();
                }
            });

            // 创建弹题点
            function createQuestionPointAliyun() {
                // console.log('加载弹题点 createQuestionPointAliyun');

                // 知识点
                var pointsTime = self.pointsTime.split(',');
                // 获取视频时长
                var duration = self.nodeData.media.mediaDuration;
                for (var j =0; j <pointsTime.length-1; j++) {
                    var importantbStart = pointsTime[j].split('+')[0]/ duration*100;
                    // 知识点结束距离左边距离
                    var importantbEnd = pointsTime[j].split('+')[1] / duration*100;
                    var importantbWidth = importantbEnd - importantbStart;
                    $('.m-progressbar').append(`<div class="importantb" style="left: ${importantbStart}%;width:${importantbWidth}%"></div>`);
                }
                for (var m=0; m<self.answer.length; m++) {
                    // 创建答题点
                    var left = self.answer[m] / duration*100;
                    $('.m-progressbar').append(`<div class="question-point" style="left: ${left}%" data-time="${left}"></div>`);
                }
            }
            function getTimes() {
                $('.handout .handout-list li').removeClass('active');
                $('.knowledge-points .knowledge-points-list li').removeClass('actives');
                // 获取当前播放时间点
                var currentTime = self.getCurrentTime();
                // console.log('currentTime', currentTime);

                self.timers = setTimeout(getTimes, 1000);
                //讲义联动
                for (var m=0; m<self.nodeData.lectures.length; m++) {
                    if (self.nodeData.lectures[m].startTime<=currentTime && self.nodeData.lectures[m].endTime>=currentTime) {
                        $('.handout .handout-list li').removeClass('active');
                        $('.handout .handout-list li').eq(m).addClass('active');
                    }
                }
                //知识点联动
                for (var s=0; s<self.nodeData.catalogKnowledgePoints.length; s++) {
                    if (self.nodeData.catalogKnowledgePoints[s].startTime<=currentTime && self.nodeData.catalogKnowledgePoints[s].endTime>=currentTime) {
                        $('.knowledge-points .knowledge-points-list li').removeClass('actives');
                        $('.knowledge-points .knowledge-points-list li').eq(s).addClass('actives');
                    }
                }
                for (var b=0; b<self.questionsOpen.length; b++) {
                    var positiveSolution='';
                    if (self.questionsOpen[b].flag && self.questionsOpen[b].mediaTime == currentTime) {
                        // 将题目的选项选中状态去掉
                        self.rightAnswers = [];
                        for (var c= 0; c<self.questionsOpen[b].optionList.length; c++) {
                            if (self.questionsOpen[b].optionList[c].correct==true) {
                                positiveSolution+=self.questionsOpen[b].optionList[c].quesValue+' ';
                                self.rightAnswers.push(self.questionsOpen[b].optionList[c].quesValue);
                            }
                        }
                        $('.positiveSolution').html('【答案】'+positiveSolution);
                        for (let options of self.questionsOpen[b].optionList) {
                            self.$set(options, 'checked', false);
                        }
                        self.question = self.questionsOpen[b];
                        self.questionVideoModal = true;
                        self.questionsOpen[b].flag = false;
                        self.moocPlayer.pause();
                        self.cancelFull();
                    }
                }
            }
            function showProgress() {
                // 自定义进度条 是否显示
                // 选择需要观察变动的节点
                const targetNode = document.getElementsByClassName('j-display')[0];
                // console.log('targetNode', targetNode);

                // 观察器的配置（需要观察什么变动）
                const config = { attributes: true, childList: false, subtree: true };

                // 当观察到变动时执行的回调函数
                const callback = function(mutationsList, observer) {
                    if (document.getElementsByClassName('f-cn')[0]) {
                        $('.progress').css({ 'top':'0' });
                    } else {
                        $('.progress').css({ 'top':'-36px', 'transition': 'top .5s' });
                    // progressDom.style.display='none';
                    }
                };
                // 创建一个观察器实例并传入回调函数
                const observer = new MutationObserver(callback);

                // 以上述配置开始观察目标节点
                observer.observe(targetNode, config);
            }
            // 播放到指定时间点
            function triggerTime() {
                // 获取当前播放时间点
                var currentTime = self.getCurrentTime();
                console.log('currentTime', currentTime);
                console.log('self.recordTime', self.recordTime);
                self.triggerTimeTask = setTimeout(triggerTime, 900);
                // 指定时间点进行录制视频
                if (self.recordConfig.recordVideoState != 1 && self.recordTime && currentTime == self.recordTime) {
                    self.recordTime = -1;
                    self.record(0);
                }
                // 存在防挂机
                if (self.recordConfig.videoOnHook != 0 && self.recordConfig.triggerType == 0) {
                    for (var b = 0; b < self.triggerValues.length; b++) {
                        // console.log('self.triggerValues[b]', self.triggerValues[b]);

                        if (self.triggerValues[b] == currentTime) {
                            // 去除当前元素
                            self.triggerValues.remove(b, 1);
                            // self.$refs.refOnHook.start();
                            if (self.recordConfig.videoOnHook == 2) {
                                self.$refs.refOnHookFace.start();
                            }
                            if (self.recordConfig.videoOnHook == 1) {
                                // 调用防挂机
                                self.$refs.refOnHookCode.start();
                            }

                            self.moocPlayer.pause();
                            self.cancelFull();
                        }
                    }
                }
            }
            // 播放启动定时任务
            let methods = self;
            // 播放时是否需要保存时长
            let isSaveTimes = true;
            self.options.videoData.start = self.learnRecord.lastTime;
            self.moocPlayer.$on('onChangeVolume', function(e) {
                // 音量改变事件
                // console.log('音量改变事件');
            });

            self.moocPlayer.$on('onMute', function(e) {
                // 静音事件
                // console.log('静音事件');
            });

            self.moocPlayer.$on('onPause', function(e) {
                // 暂停事件
                // console.log('暂停事件');
                // // 加载弹题点
                // createQuestionPointAliyun();

                // 首次加载时不需要保存时长
                if (!isSaveTimes) {
                    methods.insertOrUpdateLearnRecord(true);
                    isSaveTimes = false;
                }
            });

            // 拖拽进度条前回传听课记录
            self.moocPlayer.$on('onSeek', function({ newData, oldData }) {
                // console.log('拖拽事件');
                // 将当前视频的所有题的弹题状态变为true
                self.questionsOpen.forEach(q => q.flag = true);
            });

            self.moocPlayer.$on('onFullscreenChange', function(e) {
                // 全屏事件
                // console.log('全屏事件');
            });

            self.moocPlayer.$on('onError', function(e) {
                // 出错事件
                // console.log('出错事件');
            });
            self.moocPlayer.$on('onStartLoad', function(e) {
                // 视频开始加载事件
                // console.log('视频开始加载事件');
                // 启动定点触发任务
                triggerTime();
                // 控制是否禁止拖拽
                // if (self.isDrag) {
                if (self.isDrag) {
                    // 删除倍速播放
                    var boxWeb=document.getElementsByClassName('j-ratebtn');
                    if (boxWeb.length > 0) boxWeb[0].remove();
                    var progresswrap=document.getElementsByClassName('progresswrap');
                    if (progresswrap.length > 0) progresswrap[0].remove();
                } else {
                    $('.j-ratebtn').css({ 'display':'inline-block' });
                    $('.progresswrap').css({ 'display':'block' });
                }
            });

            // 加载一次更新时间
            self.moocPlayer.$once('onTimeupdate', function(e) {
                // console.log('加载一次, 视频播放时间更新事件', self.nodeData.media.mediaDuration);
                // 控制是否禁止拖拽
                // if (self.isDrag) {
                if (self.isDrag) {
                    // 删除倍速播放
                    var boxWeb=document.getElementsByClassName('j-ratebtn');
                    if (boxWeb.length > 0) boxWeb[0].remove();
                    var progresswrap=document.getElementsByClassName('progresswrap');
                    if (progresswrap.length > 0) progresswrap[0].remove();
                    $('.j-controlwrap').append('<div class="proogress-x"><div class="progress"><div class="played"></div></div></div>');
                    // 展示进度条
                    showProgress();
                } else {
                    $('.j-ratebtn').css({ 'display':'inline-block' });
                    $('.progresswrap').css({ 'display':'block' });
                }
            });
            // 播放开始
            self.moocPlayer.$once('onPlay', function(e) {
                // 首次加载, 播放事件
                console.log('首次加载, 播放事件');
                // 弹题
                // getTimes();
                // 启动 recordReturnTime 秒一次的定时同步任务
                if (!methods.addLearnRecordTimers) {
                    methods.addLearnRecords();
                }
                // 累计定时任务不存在，则启动本次累计时长任务
                if (!self.listenTimes) {
                    self.addListenTimes();
                }
                // 启动 sendNoticeTask 通知定时任务
                if (!methods.sendNoticeTask) {
                    methods.sendNotice();
                }

                // 保存听课记录, 首次加载章节需要保存
                if (isSaveTimes) {
                    isSaveTimes = false;
                }
                // 是否开启监管
                if (self.recordConfig && self.recordConfig.isSupervise == '1') {
                    // 首次打开发起开始学习通知
                    // if (!self.startStudyLearn) {
                    // // 开始学习
                    // self.startLearn();
                    // 关闭页面监听, 结束时发送结束学习通知
                    window.addEventListener('beforeunload', self.leaveConfirm);
                    window.addEventListener('unload', self.updateRecord);
                    // }
                }
                //     // 检查是否重新学习
                //     if (self.nodeData.tagShow == '') {
                //         if (!self.relearnTask) {
                //             self.checkRelearn(self.nodeData);
                //             self.pause();
                //         }
                //     } else {
                //         // 首次打开发起开始学习通知
                //         if (!self.startStudyLearn) {
                //         // 开始学习
                //             self.startLearn();
                //             // 关闭页面监听, 结束时发送结束学习通知
                //             window.addEventListener('beforeunload', self.leaveConfirm);
                //             window.addEventListener('unload', self.updateRecord);
                //         }
                //         // 初始化监管数据
                //         self.initFaceInfo();
                //         // 启动定点触发任务
                //         triggerTime();
                //     }
            });
            // 播放开始
            self.moocPlayer.$on('onPlay', function(e) {
                // 播放事件
                // console.log('播放事件');
                // 保存听课记录, 首次加载章节需要保存, 后暂停时才需要保存记录
                // if (isSaveTimes) {
                //     isSaveTimes = false;
                // }
                // 启动 recordReturnTime 秒一次的定时同步任务
                if (!methods.addLearnRecordTimers) {
                    methods.addLearnRecords();
                }
                // 累计定时任务不存在，则启动本次累计时长任务
                if (!self.listenTimes) {
                    self.addListenTimes();
                }
            });
            // 更新事件
            self.moocPlayer.$on('onTimeupdate', function(e) {
                // 视频播放时间更新事件
                // console.log('视频播放时间更新事件', e.currentTime, e.duration);
                // 是否开启监管
                // 控制是否禁止拖拽
                // if (self.isDrag) {
                if (self.isDrag) {
                    self.progressTime = e.currentTime / e.duration * 100;
                    if (self.progressTime > 100) {
                        self.progressTime = 100;
                    }
                    // console.log('progressTime', self.progressTime);
                    document.getElementsByClassName('played')[0].style.width=self.progressTime+'%';
                    self.$store.commit('setCurrentTime', e.currentTime);
                }
            });
            // 当前视频播放结束时调用
            self.moocPlayer.$on('onPlayEnd', function(e) {
                // 播放完毕事件
                // console.log('播放完毕事件');
                if (self.episodicStatus == true) {
                    self.chainBroadcast();
                } else {
                    // 清除所有定时任务
                    methods.clearTimeOuts();
                }
            });
            // 播放记录
            /*************************/
            /*
             * 1.点击开始播放
             * 2.获取视频时长
             * 3.创建答题节点
             * 4.创建知识点
            */
            // 点击弹题点显示题目弹窗
            $(document).on('click', '.question-point', (event) => {
                // 将题目的弹题状态置位true
                self.questionsOpen.forEach(q => q.flag = true);
                var duration = $('video').get(0).duration;
                var thisTime = $(event.target).attr('data-time')/100*duration;
                // 调整进度
                self.moocPlayer.seek(Math.round(thisTime));
                self.questionVideoModal = true;
                self.moocPlayer.pause();
            });
            // 滑过进度条，调整追加元素样式
            $('.m-progressbar').hover(function() {
                // $('.importantb').css({ 'height':'10px', 'top':'-6px' });
                $('.question-point').css({ 'width':'10px', 'height':'10px', 'top':'-3px' });
            }, function() {
                // $('.importantb').css({ 'height':'4px', 'top':'0px' });
                $('.question-point').css({ 'width':'10px', 'height':'10px', 'top':'-3px' });
            });

            // // 点击讲义列表
            // $(document).on('click', '.handout .handout-list li', (event) => {
            //     var minute = $(event.target).parent().find('.title').find('.minute');
            //     var second = $(event.target).parent().find('.title').find('.second');
            //     minuteTime=parseInt(minute.html().split(':')[0])*3600+parseInt(minute.html().split(':')[1])*60+parseInt(minute.html().split(':')[2]);
            //     secondTime=parseInt(second.html().split(':')[0])*3600+parseInt(second.html().split(':')[1])*60+parseInt(second.html().split(':')[2]);
            //     $('.handout .handout-list li').removeClass('active');
            //     $(event.target).parents('li').addClass('active');
            //     // 调整进度
            //     self.moocPlayer.seek(minuteTime);
            // });
            // $('.prism-controlbar').append('<a download class="file-download"></a>');
            // $('.file-download').attr('href', self.uploadedFileUrl);
            // if (self.uploadedFileUrl) {
            // 添加下载按钮
            // $('.g-right .f-fr').append('<a class="j-download"><div class="file-download">讲义</div></a>');
            $('.g-right .f-fr').append('<div class="file-download">讲义</div>');
            $('.j-download').attr('href', self.uploadedFileUrl);
            // }
        },
        // 获取当前时间点
        getCurrentTime() {
            let currentTime;
            if (this.moocPlayer) {
                this.moocPlayer.getPosition(time => {
                    currentTime = time;
                });
            }
            return currentTime;
        },
        // 发起通知定时任务
        sendNotice () {
            this.sendNoticeTask = setInterval(() => {
                const time = this.accumulativeTime - this.sendNoticeTime;
                if (time > 0) {
                    // 设置参数配置
                    var data = this.$store.state.questData;
                    data.progressTime = time;
                    // console.log('startLearn - data', JSON.stringify(data));
                    GuangYuanDao.sendNotice(data, (resData) => {
                        // console.log('resData', resData);
                    });
                }
                this.sendNoticeTime = this.accumulativeTime;
            }, this.sendNoticeTaskTime);
        },
        // 播放当前视频的总时长每秒记录一次
        addListenTimes() {
            this.listenTimes = setInterval(() => {
                console.log('listenTime', this.listenTime);

                this.listenTime += 1;
            }, 1000);
        },
        // 保存听课时长
        addLearnRecords () {
            this.addLearnRecordTimers = setInterval(() => {
                // console.log('this.recordReturnTime', this.recordReturnTime);

                // 保存听课记录
                this.insertOrUpdateLearnRecord();
            }, this.recordReturnTime);
        },
        // 连续播放
        chainBroadcast() {
            // 查找同父节点的章节根据序号排序
            let index = this.medias.findIndex(x => x.id == this.nodeData.id);
            let node = this.medias[index + 1];
            if (index > -1 && node) {
                this.changeMediaUrl(node);
            }
        },
        // 根据code查询课件
        findCoursewareByCode () {
            this.name = '';
            this.duration='';
            this.uploadedFileUrl='';
            let param = {
                userId : this.client.userId,
                clientCode: this.client.clientCode
            };
            this.$ClientDao.findCoursewareByCode(this.coursewareCode, param, (courseware) => {
                if (courseware) {
                    // 调整课程编码, 不存在则查询
                    if (!this.client.courseCode) this.client.courseCode = courseware.courseCode;
                    this.name= courseware.name;
                    this.coursewareId = courseware.id;
                    this.duration= Utils.getTime(courseware.duration);
                    // 默认使用 this.client.catalogId 不存在, 则使用最新的章节 ID
                    if (courseware.catalogId && !this.client.catalogId) {
                        this.client.catalogId = courseware.catalogId;
                    }
                    if (courseware.uploadedFile) {
                        this.uploadedFileUrl=courseware.uploadedFile.url;
                    }
                }
            });
        },
        // 根据课件 code 查询章节
        findChaptersByCoursewareCode() {
            let client = {
                coursewareCode: this.coursewareCode,
                clientCode: this.client.clientCode,
                userId: this.client.userId,
            };
            this.$ClientDao.findCoursewareByCilent(client, (chapters) => {
                if (chapters.length > 0) {
                    // 深拷贝原来的章节信息
                    this.oldChapters = JSON.parse(JSON.stringify(chapters));
                    this.rebuildTree(chapters);
                }
            });
        },
        // 重组树结构
        rebuildTree(chapters) {
            let newTree = [];
            // 判断是否有上一次的学习记录没有默认显示第一章节
            let chapter = null;
            let firstMedia = null;
            // 找到每个节点的子节点
            for (let tree of chapters) {
                tree.tagShow = 'none';
                tree.children = [];
                tree.expand = true;
                // 获取第一个视频章节
                if (!firstMedia && tree.isMedia == 1) firstMedia = tree;
                // 判断是否有上一次的学习记录没有默认显示第一章节
                // if (!tree.lastCatalogId) chapter = tree;
                if (!chapter && this.client.catalogId == tree.id) chapter = tree;
                for (let child of chapters) {
                    if (child.pId == tree.id) {
                        tree.children.push(child);
                    }
                }
            }
            // 过滤掉除第一节点外的数据
            newTree = chapters.filter(x => x.pId == 0);
            this.chapters.push(...newTree);
            if (!chapter) {
                chapter = firstMedia;
            }
            this.changeCode(chapter);
            // 获取企业配置
            this.getConfig();
        },
        // 过滤出所有视频
        filterMedias(chapters) {
            for (let chapter of chapters) {
                if (chapter.isMedia == 1) {
                    this.medias.push(chapter);
                }
                if (chapter.children.length > 0) {
                    this.filterMedias(chapter.children);
                }
            }
        },
        // 改变章节重置对象
        changeCode(data) {
            if (data.id == this.nodeData.id) {
                return;
            }
            this.nodeData = data;
            // 准备查询讲义、题目、知识点
            this.nodeData.lectures = [];
            this.nodeData.catalogKnowledgePoints = [];
            this.nodeData.questions = [];
            // 是媒体查询媒体信息
            if (this.nodeData.isMedia == 1) {
                this.client.catalogId = data.id;
                this.$store.commit('setCatalogId', this.client.catalogId);
                Utils.setCookie(this.$route.query.uid, JSON.stringify(this.client), 6, '/page/;');
                // 查询弹题、讲义、知识点
                this.findLecturesMediaKnowledgePointsQuestions();
                // 查询当前视频听课记录
                this.findLearnRecordByUser();
            }
            // 设置参数配置
            var questData = this.$store.state.questData;
            // 章节 ID
            questData.sectionCode = this.nodeData.parentId;
            // 设置参数配置
            this.$store.commit('setQuestData', questData);
        },
        // 数组对象排序
        compare(property) {
            return function(a, b) {
                var value1 = a[property];
                var value2 = b[property];
                return value1 - value2;
            };
        },
        // 根据课件编码和章节 ID 及媒体 ID 获取讲义/知识点/弹题列表
        findLecturesMediaKnowledgePointsQuestions() {
            this.pointsTime = '';
            this.answer = [];
            this.questionsOpen= [];
            this.nodeData.lectures= [];
            this.mediaTitle= '';
            this.nodeData.catalogKnowledgePoints=[];
            let client = {
                clientCode: this.client.clientCode,
                userId: this.client.userId,
                isQuestion: this.client.isQuestion,
                coursewareCode: this.coursewareCode,
            };
            this.$ClientDao.findLecturesMediaKnowledgePointsQuestions(this.nodeData.id, client, (catalog) => {
                this.mediaTitle=catalog.title;
                if (catalog) {
                    // 获取媒体
                    if (catalog.media) {
                        this.nodeData.media = catalog.media;
                    }
                    // 获取讲义
                    if (catalog.lectures.length > 0) {
                        this.nodeData.lectures.push(...catalog.lectures.sort(this.compare('startTime')));
                    }
                    // 获取知识点
                    if (catalog.catalogKnowledgePoints.length > 0) {
                        this.nodeData.catalogKnowledgePoints.push(...catalog.catalogKnowledgePoints.sort(this.compare('startTime')));
                        var pointsTime='';
                        for (var i=0; i<this.nodeData.catalogKnowledgePoints.length; i++) {
                            pointsTime+= this.nodeData.catalogKnowledgePoints[i].startTime+'+'+this.nodeData.catalogKnowledgePoints[i].endTime+',';
                        }
                        this.pointsTime=pointsTime;
                    }
                    // 获取弹题
                    if (catalog.questions.length > 0) {
                        this.nodeData.questions.push(...catalog.questions);
                        this.answer = this.nodeData.questions.map(x => x.mediaTime);
                        for (let question of this.nodeData.questions) {
                            this.$set(question, 'flag', true);
                            this.questionsOpen.push(question);
                        }
                    }
                }
            });
        },
        // 视频弹窗点击取消
        videoCancel() {
            this.questionVideoModal = false;
            this.$refs.modal.close();
        },
        // 当人脸识别弹窗变化时
        colseFaceModal(value) {
            if (value) {
                // 暂停
                this.moocPlayer.pause();
                // 退出全屏
                this.cancelFull();
            } else {
                // 人脸识别结束
                // 设置设备使用中
                // this.$store.commit('setVideoDevice', false);
                if (this.videoStartFaceOnce) {
                    this.videoStartFaceOnce = false;
                    this.$store.commit('setVideoStartFaceOnce', this.videoStartFaceOnce);
                }
                // 关闭时进行播放, 当有弹题弹窗时不播放
                if (!this.questionVideoModal && !this.$store.state.isCodeloading && !this.$store.state.isVideoRecordloading) {
                    this.moocPlayer.resume();
                }
            }
        },
        // 当验证码弹窗变化时
        colseCodeModal(value) {
            if (value) {
                // 暂停
                this.moocPlayer.pause();
                // 退出全屏
                this.cancelFull();
            } else {
                // 验证码 打卡结束
                // 关闭时进行播放, 当有弹题弹窗时不播放
                if (!this.questionVideoModal && !this.$store.state.isFaceloading && !this.$store.state.isVideoRecordloading) {
                    this.moocPlayer.resume();
                }
            }
        },
        // 视频发送完成
        colseVideoRecordModal (value) {
            if (value) {
                // 暂停
                this.moocPlayer.pause();
                // 退出全屏
                this.cancelFull();
            } else {
                // 验证码 打卡结束
                // 关闭时进行播放, 当有弹题弹窗时不播放
                if (!this.questionVideoModal && !this.$store.state.isFaceloading && !this.$store.state.isCodeloading) {
                    this.moocPlayer.resume();
                }
            }
        },
        // 测评题对话框变化时
        colseModal(value) {
            if (!value) {
                // 关闭时进行播放, 当有 face 弹窗时不播放
                if (!this.faceInfoModal) this.moocPlayer.resume();
                this.buttonType = 1;
                this.showAnalysis = false;
                // 重置弹题数据
                this.learnRecord.questionId = 0;
                this.learnRecord.examinePoint = '';
                this.learnRecord.isPass = null;
            }
        },
        // 切换弹题、讲义、知识点菜单栏
        changeType(type) {
            this.type = type;
        },
        // 标记选项为正确的或者错误的
        chooiceAnswer(question, optionIndex) {
            if (this.readOnly) { return; }
            this.$QuestionUtils.chooiceAnswer(question, optionIndex);
        },
        // 每 5 分钟校验一次用户权限，以防权限过期
        checkClickCookie() {
            // 获取 cookie 和 url 中的信息
            let uId = this.$route.query.uid;
            // let uId = '852013';
            let str = Utils.getCookie(uId);
            if (str == null || str== '') {
                this.errorRouter('视频浏览权限已失效！');
            }
        },
        // 校验第三方用户权限
        checkClickAuth() {
            // 获取 cookie 和 url 中的信息
            let uId = this.$route.query.uid;
            // let uId = '852013';
            let str = Utils.getCookie(uId);
            let errorMsg = decodeURIComponent(this.$route.query.errorMsg);
            if (str && errorMsg == 'undefined') {
                let client = JSON.parse(str);
                if (typeof client === 'string') {
                    client = JSON.parse(client);
                }
                client.userName = decodeURIComponent(client.userName);
                client.courseName = decodeURIComponent(client.courseName);
                this.client = client;
            } else {
                // 跳转错误页
                this.errorRouter(errorMsg);
            }
        },
        // 查询当前视频最新的听课记录
        findLearnRecordByUser() {
            // 获取第三信息初始化听课记录
            this.learnRecord = {
                learnRecordId   : 0,
                userId          : this.client.userId,
                userName        : this.client.userName,
                clientCode      : this.client.clientCode,
                businessLineCode: this.client.businessLineCode,
                courseCode      : this.client.courseCode,
                coursewareCode  : this.client.coursewareCode,
                coursewareName  : this.name,
                catalogId       : this.nodeData.id,
                catalogTitle    : this.nodeData.title,
                videoTime       : this.nodeData.mediaDuration, // 视频总时长
                backUrl         : this.client.backUrl, // 业务系统听课记录回传地址
                validTime       : 0,         // 有效学习时长(当前视频播放最长的点)
                lastTime        : 0,          // 当前媒体播放时间点 (小于等有效时长)
                listenTime: 0,  // 本次累计时长
            };
            // 查询当前指定视频的上次播放时间点
            this.$ClientDao.findLearnRecordByUser(this.learnRecord, (learnRecord) => {
                if (learnRecord) {
                    this.learnRecord.lastTime = learnRecord.lastTime;
                    this.videoStartFaceOnce = false;
                } else {
                    this.videoStartFaceOnce = true;
                }
            });
        },
        // 插入或者修改听课记录
        insertOrUpdateLearnRecord(isPause) {
            // 当前媒体播放时间点
            if (this.moocPlayer) {
                this.moocPlayer.getPosition(currentTime => {
                    this.learnRecord.lastTime = currentTime;
                });
            }
            // console.log('savelastTime', this.learnRecord.lastTime);

            // 同步累计时长相同且不为 0 则不进行保存
            // if (this.learnRecord.accumulativeTime === this.accumulativeTime && this.accumulativeTime != 0 && this.learnRecord.isPass === null) return;
            // 同步累计时长相同且不为 0 则不进行保存
            if (this.learnRecord.isPass === null) return;
            // 清除 recordReturnTime 秒一次的定时同步任务
            if (this.addLearnRecordTimers) {
                clearInterval(this.addLearnRecordTimers);
                this.addLearnRecordTimers = null;
                // 启动 recordReturnTime 秒一次的定时同步任务
                if (!isPause) this.addLearnRecords();
            }
            this.learnRecord.listenTime = this.listenTime;
            // 清除 listenTimes 定时同步任务
            if (this.listenTimes) {
                clearInterval(this.listenTimes);
                this.listenTimes = null;
                this.listenTime = 1;
                // 启动 recordReturnTime 秒一次的定时同步任务
                if (!isPause) this.addListenTimes();
            }
            // 是否开启监管
            // if (this.recordConfig && this.recordConfig.isSupervise == '1') {
            // 限制学习时长
            this.learnRecord.studyHour = this.recordConfig.studyHourLimit;
            this.learnRecord.authCode = this.questData.authCode;
            this.learnRecord.deviceType = this.questData.deviceType;
            this.learnRecord.relativeProjectId = this.questData.relativeProjectId;
            // }

            this.moocPlayer.getPosition(currentTime => {
                this.learnRecord.lastTime = currentTime;
                this.$ClientDao.saveLearnRecord(this.learnRecord, (result) => {
                    if (result == false) {
                        this.moocPlayer.pause();
                    } else {
                        if (learnRecord.endStudy) {
                            this.errorRouter('今日学习时长已完成!');
                        }
                    }
                });
            });
        },
        // 弹题答案提交
        sumbitAnswer() {
            // 过滤学生选择的答案
            let checkList = this.question.optionList.filter(x => x.checked == true);
            if (checkList.length > 0) {
                this.buttonType = 2;
                this.showAnalysis = true;
                // 验证答案是否正确
                let rightAnswers = checkList.filter(x => this.rightAnswers.includes(x.quesValue));
                this.learnRecord.questionId = this.question.questionId;
                this.learnRecord.examinePoint = this.question.examinePoint;
                this.learnRecord.isPass = false;
                // 验证是否正确, 选择的数量和正确的数量, 和选对的数量要一致!
                if (rightAnswers.length == this.rightAnswers.length && checkList.length == this.rightAnswers.length) {
                    this.learnRecord.isPass = true;
                }
            } else {
                this.$Message.warning('请作答！');
            }
        },
        // 绝对暂停课件播放
        pause() {
            var self = this;
            self.facePause = setTimeout(() => {
                self.moocPlayer.getState(state => {
                    // if (state === 'PLAYING') {
                    //     // 弹题
                    //     getTimes();
                    // }
                    // console.log('state1', state);
                    if (state == 'PLAYING') {
                        // console.log('state2', state);
                        self.moocPlayer.pause();
                        clearTimeout(self.facePause);
                    } else if (state == 'PAUSED') {
                        // console.log('state3', state);
                        clearTimeout(self.facePause);
                    } else {
                        // console.log('state4', state);
                        self.pause();
                    }
                });
            }, 300);
        },
        // 开始学习接口
        startLearn() {
            this.faceRecognition = true;
            this.validateCode = true;
            var self = this;
            // 设置参数配置
            var data = this.$store.state.questData;
            data.deviceId = Utils.getUUID();
            // console.log('startLearn - data', JSON.stringify(data));
            GuangYuanDao.startStudy(data, (resData) => {
                // console.log('resData', resData);
                self.startStudyLearn = true;
            });
        },
        // 结束学习接口
        endLearn() {
            // 移除组件
            this.clearTimeOuts();
            // this.componentKeyFace +=1;
            // this.componentKeyCode +=1;
            // this.videoRecording = false;
            // var data    = {
            //     authCode         : '', // 授权码
            //     courseCode       : '', // 课程编码
            //     deviceId         : '', // 设备唯一标识：PC和H5和IOS取UUID,Android取MAC(需去除冒号)
            //     deviceType       : '', // 设备类型：PC端 = TYPE_PC，H5端 = TYPE_H5，Android端 = TYPE_ANDROID，IOS端 = TYPE_IOS（请传入对应的类型代码）
            //     relativeProjectId: '', // 项目班级id
            //     resCode          : '', // 资源编码
            //     courseWareCode   : self.client.coursewareCode, // 课件编码
            // };
            // 设置参数配置
            var data = this.$store.state.questData;
            data.deviceId = Utils.getUUID();
            console.log('endLearn - data', JSON.stringify(data));
            // 关闭时阻止页面, 发送结束后关闭页面;
            navigator.sendBeacon(Urls.CLIENT_CLEAN_END_STUDY, JSON.stringify(data));
        },
        // 初始化人脸识别
        initFaceInfo() {
            console.log('this.recordConfig', this.recordConfig);
            // if (this.recordConfig.videoOnHook == 1) {
            //     // 验证码弹框
            //     this.validateCode = true;
            // }
            // if (this.recordConfig.videoOnHook == 2) {
            //     // 人脸识别弹框
            //     // 需要人脸识别
            //     this.faceRecognition = true;
            // }
            // 首次是否需要人脸识别
            if (this.videoStartFaceOnce && this.recordConfig.videoStartFace == 1) {
                // 需要人脸识别
                this.$refs.refOnHookFace.start();
            }
            // 存在防挂机, 且触发条件为固定次数
            if (this.recordConfig.videoOnHook != 0) {
                if (this.recordConfig.triggerType == 0) {
                    this.triggerValues = [];
                    for (let index = 0; index < this.recordConfig.triggerValue; index++) {
                        var videoOnHookTime = parseInt(this.nodeData.media.mediaDuration / (this.recordConfig.triggerValue + 1) * (index + 1));
                        this.triggerValues.push(videoOnHookTime);
                    }
                } else {
                    // 调用防挂机打卡
                    if (this.recordConfig.videoOnHook == 1) {
                        this.$refs.refOnHookCode.start();
                    }
                    if (this.recordConfig.videoOnHook == 2) {
                        this.$refs.refOnHookFace.start();
                    }
                }
                // console.log('this.triggerValues', this.triggerValues);
            }
            if (this.recordConfig.videoPlayRecord == 1) {
                // 录制需要
                this.videoRecording = true;
                // 视频录制方式 1: 视频开始后；2: 1/4；3 :1/3；4: 1/2；
                this.recordTime = null;
                if (this.recordConfig.recordVideoState == 1) {
                    // 开始录制
                    this.record(0);
                } else if (this.recordConfig.recordVideoState == 2) {
                    this.recordTime = parseInt(this.nodeData.media.mediaDuration / 4);
                } else if (this.recordConfig.recordVideoState == 3) {
                    this.recordTime = parseInt(this.nodeData.media.mediaDuration / 3);
                } else if (this.recordConfig.recordVideoState == 4) {
                    this.recordTime = parseInt(this.nodeData.media.mediaDuration / 2);
                }
                console.log('this.recordTime', this.recordTime);
            }
            // 暂停
            // this.pause();
        },
        // 获取监管配置
        getConfig() {
            var self = this;
            // 存在参数, 获取配置
            GuangYuanDao.configUp(this.client.authCode, this.client.projectClassId, (resData) => {
                // console.log('resData', resData);
                // 监控配置
                self.recordConfig = {
                    isSupervise: resData.isSupervise, // 是否监管
                    // isSupervise: '1', // 是否监管
                    // 防挂机设置 防挂机配置，取值如下：0=不需要, 1=弹验证码, 2=人脸识别
                    videoOnHook: resData.superviseConfig.videoOnHook,
                    // videoOnHook: 1,
                    // 视频首次开始观看时人脸识别,0=不需要,1=需要
                    videoStartFace : resData.superviseConfig.videoStartFace,
                    // videoStartFace : 1,
                    // 触发方式,0=固定次数,1=固定时间,2=每次递增
                    triggerType : resData.superviseConfig.triggerType,
                    // 触发的值，根据类型triggerType来设置：当triggerType=0时，表示是按照次数来，当triggerType=1或者triggerType=2时，表示时按照分钟来
                    triggerValue : resData.superviseConfig.triggerValue,
                    // triggerValue : 1,

                    // 视频播放中录制视频,0=不需要,1=需要
                    videoPlayRecord : resData.superviseConfig.videoPlayRecord,
                    // videoPlayRecord : 1,
                    // 视频录制方式 1:视频开始后；2:1/4 ；3:1/3；4:1/2；
                    recordVideoState: resData.superviseConfig.recordVideoState,
                    // recordVideoState: 1,
                    // 视频录制时长15s 30s 45s 60s
                    recordVideoTime: resData.superviseConfig.recordVideoTime,
                    // recordVideoTime: 5,
                    studyHourLimit: resData.superviseConfig.studyHourLimit, // 时长限制
                    // studyHourLimit: 8, // 时长限制
                };
                // 参数配置
                self.questData = {
                    authCode         : self.client.authCode, // 授权码
                    courseCode       : self.client.courseCode, // 课程编码
                    deviceId         : Utils.getUUID(), // 设备唯一标识：PC和H5和IOS取UUID,Android取MAC(需去除冒号)
                    deviceType       : 'TYPE_PC', // 设备类型：PC端 = TYPE_PC，H5端 = TYPE_H5，Android端 = TYPE_ANDROID，IOS端 = TYPE_IOS（请传入对应的类型代码）
                    relativeProjectId: self.client.projectClassId, // 项目班级id
                    courseWareCode   : self.client.coursewareCode, // 课件编码
                    resCode          : self.nodeData.id, // 资源编码, 视频所在章节 ID
                    sectionCode      : self.nodeData.parentId, // 章节 ID, 视频所在章节父 ID
                };
                // 设置参数配置
                self.$store.commit('setQuestData', self.questData);
                // 设置监管配置
                self.$store.commit('setRecordConfig', self.recordConfig);
                if (self.recordConfig.isSupervise == '1') {
                    // // 判断是否第一次学习该视频, 是否需要人脸识别
                    if (self.recordConfig.videoStartFace == 1 && self.videoStartFaceOnce == true) {
                        self.videoStartFaceOnce = true;
                        self.$store.commit('setVideoStartFaceOnce', self.videoStartFaceOnce);
                    }
                    // 获取重学数据
                    self.getRelearn();
                }
                // 播放用户选择的视频
                if (JSON.stringify(self.nodeData.media)) {
                    self.playVideo(self.nodeData);
                }
                // Utils.success('开始学习接口调用成功');
                // console.log('获取配置成功');
            });
        },
        // 获取重学列表
        getRelearn() {
            // 存在参数, 获取配置
            GuangYuanDao.reLearnList(this.client.authCode, this.client.projectClassId, (resData) => {
                // console.log('获取重学列表resData', resData);
                this.resCodes = resData;
                // this.resCodes = [
                //     { rescode:'540077284288102407', status:0 },
                //     { rescode:'540077284288102411', status:0 },
                //     { rescode:'540077284288102403', status:0 },
                // ];
                if (this.resCodes && this.resCodes.length > 0) {
                    // this.rebuildTree(self.oldChapters, this.resCodes);
                    // let resCodeMap = new Map();
                    this.resCodeMap = new Map();
                    this.resCodes.forEach(res => {
                        this.resCodeMap.set(res.rescode, res);
                    });
                }
                this.chaptersTra(this.chapters);
            });
        },
        chaptersTra(chapters) {
            chapters.forEach(ch => {
                // 查询是否重学
                if (this.resCodeMap && this.resCodeMap.size > 0) {
                    // console.log('====', this.resCodeMap.get(ch.id+''));
                    if (this.resCodeMap.get(ch.id+'') && this.resCodeMap.get(ch.id+'').status == 0) {
                    // if (this.resCodeMap.get(ch.id+'')) {
                        ch.tagShow='';
                    }
                }
                if (ch.children && ch.children.length > 0) {
                    this.chaptersTra(ch.children);
                }
            });
        },
        // 退出全屏
        cancelFull() {
            if (this.moocPlayer) this.moocPlayer.exitFullScreen();
        },
        // error 跳转
        errorRouter(msg) {
            // let errorMsg = '视频浏览权限已失效！';
            // 移除组件
            this.clearTimeOuts();
            this.faceRecognition = false;
            this.videoRecording = false;
            this.validateCode = false;
            // 跳转错误页
            this.$router.push({
                name: 'player-error',
                params: {
                    error: msg
                }
            });
        },
    },
    // 结束组件
    destroyed () {
        window.removeEventListener('beforeunload', this.leaveConfirm);
        window.removeEventListener('unload', this.updateRecord);
    }
};

</script>

<style lang="scss">
.mooc-charge-courseware-preview{
    position: relative;
    overflow: hidden;
    height: 100%;
    h3{
        height: 60px;
        line-height: 60px;
        color: #b0b6d6;
        padding-left: 20px;
        font-size: 16px;
        background: #333749;
    }
    .mediaDuration{
        position: absolute;
        top: 20px;
        right: 0;
        padding-right: 30px;
        dt{
            font-size: 18px;
            font-weight: bold;
            color: #b0b6d6;
            float: left;
        }
        dd{
            padding-top: 3px;
            font-size: 14px;
            color: #b0b6d6;
            float: left;
            padding-left: 30px;
        }
        .chain-broadcast {
            float: left;
            padding-left: $gap;
            padding-top: 2px;
            .chain-title {
                font-size: 14px;
                font-weight: bold;
                color: #b0b6d6;
                margin-right: 5px;
            }
        }
    }
    .ivu-split-trigger-vertical{
        background: black;
        border:none;
    }
    .ivu-split-trigger-vertical .ivu-split-trigger-bar{
        background: #fff;
    }
    .video-conct{
        background:#222638;
        height:100%;
    }
    // 视频区域
    .video-box{
        width: 74vw;
        height: 92vh;
        float: left;

        // 慕课播放器标签
        .prism-player-mooc {
            width: 100%;
            height: 100%;
            .f-fr .j-download{
                height: 27px;
                float: right;
                .file-download {
                    width: 1rem;
                    height: 0.8125rem;
                    text-decoration: none;
                    text-align: center;
                    line-height: 0.8125rem;
                    color: #fff;
                    font-size: 14px;
                }
            }
            .j-controlwrap {
                // 播放器进度条
                .progresswrap {
                    display: none;
                }
            }
            .j-ratebtn {
                display: none;
            }
            // 在修改声音样式中, 取消自定义弹题点
            .m-popover{
                // bottom: 36px;
                .question-point {
                    display: none;
                }
            }
            // 进度条上弹题点
            .m-progressbar {
                .question-point {
                    position: absolute;
                    top: -3px;
                    width: 10px;
                    height: 10px;
                    border: 1px solid blue;
                    border-radius: 50%;
                    background: red;
                    z-index: 100000;
                    cursor:pointer;
                    transform:translate(-50%);
                }
                .question-point:hover {
                    border: 1px solid white;
                    background: orange;
                }
                .progressbar {
                    background-color: #00c1de;
                }
            }
            .u-edu-h5player-controlwrap .m-controlbar .controlbar_btn {
                height: 27px;
            }
            .u-edu-h5player-controlwrap .bigplaybtn {
                height: 40px;
                padding: 4px 0;
            }

            .proogress-x {
                // display: none;
                width: 100%;
                position: absolute;
                bottom: 0;
                .progress{
                    transition:.5s;
                    z-index: 2;
                    // top: 0;
                    width: 100%;
                    height: 4px;
                    background: rgba(195,197,198,.5);
                    box-shadow: inset 1px 1px 1px 0 rgba(0,0,0,.06);
                    position: relative;
                    cursor: pointer;
                    .played{
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 0;
                        height: 100%;
                        background-color: #00c1de;
                    }
                    // &:hover {
                    //     top: -40px;;
                    //     transition: top .5s;
                    // }
                }
            }

        }
        // &:hover {
        //     .proogress-x .progress{
        //         top: -40px;
        //         transition: top .5s;
        //     }
        // }
    }
    // 视频右侧列表
    .video-nav{
        float: right;
        width: 25vw;
        height: 92vh;
        position: relative;
        .video-box-right{
            text-align: center;
            width: 100%;
            background: #2a2e41;
            padding-top: 12px;
            div{
                display: inline-block;
                padding: 0px 10px;
                margin: 0px 10px;
                span{
                    position: relative;
                    top: 2px;
                    color: #6d728c;
                    cursor: pointer;
                    padding-left: 5px;
                    font-size: 16px;
                }
            }
            .ivu-icon{
                font-size: 28px;
                color: #6d728c;
                cursor:pointer;
            }
            .actived {
                color: #b0b6d6;
                border-bottom: 3px solid #b0b6d6;
                padding-bottom: 8px;
                .ivu-icon{
                    color: #b0b6d6;
                }
                span{
                    color: #b0b6d6;
                }
            }
        }
        .video-box-left{
            height: 88vh;
            width: 100%;
            overflow-y: auto;
            overflow-x: hidden;
            padding: 16px;
            color: #b0b6d6;
            // position: relative; // 固定收缩课件章节目录列表
            .ivu-tree {
                overflow-y: auto;
                overflow-x: hidden;
                ul li{
                    cursor:pointer;
                    font-size: 14px;
                }
            }
             .global-nodata {
                display: flex;
                height: 100%;
                .description {
                    color: white;
                }
            }
            .fold{
                display: inline-block;
                position: absolute;
                left: 0px;
                width: 12px;
                text-align: center;
                height: 60px;
                background: #333749;
                line-height: 60px;
                border-radius: 0px 5px 5px 0px;
                top: 40%;
                margin-top: -30px;
                cursor: pointer;
            }
            .render-content {
                .active {
                    color: $primaryColor;
                }
            }
        }
        .brief{
            .handout-list{
                .active{
                    border: 1px solid red;
                }
                li{
                    list-style: none;
                    border: 1px solid #515a6e;
                    padding: 8px;
                    margin-bottom: 16px;
                    cursor:pointer;
                    position: relative;
                    p{
                        word-break: break-all;
                        padding-bottom: 8px;
                        span{
                            padding-left: 5px;
                            padding-right: 5px;
                        }
                    }
                    h1{
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        top: 0;
                        left: 0;
                        z-index: 2;
                    }
                }
            }
            .knowledge-points-list{
                .actives{
                    border: 1px solid #fff;
                }
                li{
                    list-style: none;
                    border: 1px solid #515a6e;
                    padding: 8px;
                    margin-bottom: 16px;
                    cursor:pointer;
                    position: relative;
                    p{
                        padding-bottom: 8px;
                        span{
                            padding-left: 5px;
                            padding-right: 5px;
                        }
                    }
                    h1{
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        top: 0;
                        left: 0;
                        z-index: 2;
                    }
                }
            }
        }
    }
    .prism-controlbar{
        bottom: 10px!important;
    }
    .points span{
            display: inline-block;
            padding: 5px 10px;
    }
    .importantb{
       position: absolute;
       top: 0px;
       height: 4px;
       left: 400px;
       background: red;
       width: 50px;
    }
    .prism-controlbar{
        display: block!important;
    }
    .prism-progress-cursor{
        z-index: 5;
    }
    // 评课
    .error-courseware, .comment-courseware {
        display: block;
        height: 30px;
        width: 30px;
        background-color: $successColor;
        border-radius: 30px;
        margin-top: 12px!important;
        float: right;
        margin-right: 5px;
        font-size: 10px;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor:pointer;
    }
}
// 提示弹窗
.mooc-charge-relearn-modal {
    .ivu-modal-footer {
        text-align: center;
    }
}
// 弹题作答对话
.mooc-charge-preview-modal {
    .question-stem-preview{// 弹题作答提示!
        .pass{
            float: right;
            font-weight: bold;
            font-size: 20px;
            color: green;
        }
        .fail{
            float: right;
            font-weight: bold;
            font-size: 20px;
            color:red;
        }
        padding-bottom: 10px;
    }
    // 问题的选项
    .question-options {
        flex: 1;

        // 单选题、多选题选项
        .question-option {
            display: flex;
            margin-bottom: $gap;
            &:hover {
                .mark {
                    color: white;
                    background: $primaryColor;
                }
            }

            // 单选题、多选题选项的标记 A, B, C, D
            .mark {
                // 圆形
                min-width : $optionWidth;
                min-height: $optionWidth;
                max-width : $optionWidth;
                max-height: $optionWidth;
                border-radius: 50%;
                margin-right: $gap;
                @include alignCenter;
                border: 1px solid $separatorColor;
                cursor: pointer;

                // 正确选项
                &.correct {
                    color: white;
                    background: $primaryColor;
                }
                &:hover {
                    color: white;
                    background: $primaryColor;
                }
            }
            .option-list {
                line-height: 28px;
            }
        }

        // 判断题
        &.question-optioins-tfng {
            display: flex;

            // 判断题的答案按钮
            .question-optioin-tfng {
                @include alignCenter;
                width: 70px;
                height: $optionWidth - 2;
                border: $optionBorder;
                border-radius: $borderRadius;
                cursor: default;

                // 正确答案按钮
                &.correct {
                    color: white;
                    background: $primaryColor;
                    border-color: $primaryColor;
                }

                // 左边按钮
                &:first-child {
                    border-top-right-radius: 0;
                    border-bottom-right-radius: 0;
                    border-right-width: 0;
                    margin-right: 0;
                }

                // 右边按钮
                &:last-child {
                    border-top-left-radius: 0;
                    border-bottom-left-radius: 0;
                    border-left-width: 0;
                }
            }
        }
    }
    .button-box-preview{
        text-align: center;
    }
    .question-analysis-preview-box {
        .question-analysis-preview{
            padding-left: 10px;
            .title-desc-preview, .positiveSolution {
                font-weight: bold;
            }
        }
        .question-knowledge-point-preview{
            padding-left: 10px;
        }
    }
}

</style>
